// ============================================================================
// Custom Hook: useEventBusEmit - Get a stable emit function
// ============================================================================
import { useCallback } from "react";

import { type EventBusEventsType, eventBus } from "./event-bus";

/**
 * Returns a stable emit function for an event
 * Useful when you only need to emit, not listen
 */
export function useEventBusEmit<E extends keyof EventBusEventsType>(event: E) {
  return useCallback(
    (payload: EventBusEventsType[E]) => {
      eventBus.emit(event, payload);
    },
    [event]
  );
}
